import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "result-card-list" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "result-card-list__items"
}
const _hoisted_4 = {
  key: 1,
  class: "result-card-list__message"
}
const _hoisted_5 = { class: "result-card-list__bottom" }
const _hoisted_6 = { class: "result-card-list__displayed-results" }
const _hoisted_7 = {
  key: 1,
  class: "result-card-list__message"
}

import { computed } from 'vue';
import { columnConfig, IColumnItem } from '@/interfaces/search/IQueryColumn';
import { useStore } from "@/stores/store";

import Pagination from '@/components/pagination/Pagination.vue';
import ResultCard from '@/components/resultcard/ResultCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResultCardList',
  setup(__props) {

const store = useStore();

const noVisibleColumns = computed(() => {
  return Object.values(columnConfig).every((config: IColumnItem) => !config.visible);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "result-card-list__header" }, "Namn", -1 /* HOISTED */)),
    (_unref(store).searchResult?.results != null && _unref(store).searchResult.results.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!noVisibleColumns.value)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).displayedResults, (hit) => {
                  return (_openBlock(), _createBlock(ResultCard, {
                    key: hit.uuid,
                    result: hit,
                    columnConfig: _unref(columnConfig)
                  }, null, 8 /* PROPS */, ["result", "columnConfig"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, " Du måste välja minst en kolumn för att visa sökresultat. ")),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("strong", null, _toDisplayString(_unref(store).displayedResults.length), 1 /* TEXT */),
              _createTextVNode(" av " + _toDisplayString(_unref(store).searchResult?.results.length) + " träffar ", 1 /* TEXT */)
            ]),
            _createVNode(Pagination, { "page-window-size": 2 })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, " Inget resultat hittades "))
  ]))
}
}

})